interface ApiErrorShape {
  response?: { data?: { message?: unknown; error?: unknown } };
  message?: unknown;
}

const asText = (value: unknown) => (typeof value === 'string' && value.trim() ? value : null);

export function toErrorMessage(error: unknown, fallback: string): string {
  if (typeof error === 'string') return asText(error) ?? fallback;

  const shape = error as ApiErrorShape;
  const data = shape?.response?.data;

  return asText(data?.message) ?? asText(data?.error) ?? asText(shape?.message) ?? fallback;
}
